<template>
    <thead class="table-head">
        <tr class="table-head-row">
            <th scope="col" class="table-head__checkbox">
                <CheckBox
                    :checked="isCurrentPageSelected"
                    @onClick="handleSelectPage"
                    :aria-label="`Select all contacts on the current page`"
                />
            </th>
            <th
                v-for="(
                    columnHeader, index
                ) in columnHeaders"
                :key="index"
                scope="col"
                :class="`table-head__${columnHeader.className}`"
            >
                {{ columnHeader.name }}
            </th>
        </tr>
    </thead>
</template>

<script>
import CheckBox from '@/views/client-connect-v2/CheckBox.vue';
import { mapActions, mapState } from 'vuex';

export default {
	name: 'RecipientTableHeader',
	components: {
		CheckBox,
	},
    data() {
        return {
            columnHeaders: [
                {
                    name: 'Full Name',
                    value: 'lastName',
                    className: 'name',
                },
                {
                    name: 'Email Address',
                    value: 'email',
                    className: 'email',
                },
            ],
        };
	},
    props: {
        currentPageContacts: Array,
        selectAllMode: Boolean,
    },
    computed: {
        ...mapState({
			leadIds: (state) => state.bbSelectRecipientModal.leadIds,
		}),
        currentPageLeadIds() {
			return this.currentPageContacts.map((contact) => contact.leadId);
		},
		isCurrentPageSelected() {
			if (this.selectAllMode) {
				return (
					this.currentPageLeadIds.every((id) =>
						!this.leadIds.includes(id),
					)
				);
			} else {
				return (
					this.currentPageLeadIds.every((id) =>
						this.leadIds.includes(id),
					)
				);
			}
		},
    },
	methods: {
        ...mapActions([
			'setLeadIds',
		]),
        handleSelectPage(selected) {
			selected = this.selectAllMode ? !selected : selected;
			const currentPageLeadIds = this.currentPageContacts.map(
				(contact) => contact.leadId,
			);
			if (selected) {
				const filtered = currentPageLeadIds.filter(
					(item) => !this.leadIds.includes(item),
				);
				this.setLeadIds([...this.leadIds, ...filtered]);
			} else {
				this.setLeadIds(this.leadIds.filter(
					(id) => !currentPageLeadIds.includes(id),
				));
			}
		},
	},
};
</script>

<style lang="scss" scoped>
    .table-head-row {
        display: grid;
        grid-template-columns: 4% 40% 52%;
        gap: 2%;
        align-items: center;
        background: $header-color-light;
        border-radius: 6px 6px 0 0;
        @include rem('padding', 12px);

         th {
            text-align: start;
            cursor: pointer;
        }
    }

    @media only screen and (max-width: 600px) {
        .table-head-row {
            gap: 4%;
            grid-template-columns: 5% auto;
        }

        .table-head__email {
            display: none;
        }
    }
</style>
